import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "text-disabled text-caption" }
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = {
  key: 1,
  class: "text-center"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "d-flex justify-center pa-2"
}
const _hoisted_6 = { class: "text-disabled text-caption d-flex align-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_ossDatePicker_filled = _resolveComponent("ossDatePicker-filled")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_SettingConnectorImportMapping = _resolveComponent("SettingConnectorImportMapping")!
  const _component_SettingConnectorRefetchData = _resolveComponent("SettingConnectorRefetchData")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_setting_card = _resolveComponent("setting-card")!

  return (_openBlock(), _createBlock(_component_setting_card, _mergeProps(_ctx.binds, {
    dialogBind: _ctx.dialogBind,
    width: _ctx.dialogWidth,
    closeOnValid: false,
    active: _ctx.localActive,
    "onUpdate:active": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localActive) = $event)),
    comingSoon: _ctx.comingSoon,
    disableConfiguration: _ctx.disableConfiguration,
    hidePrevious: false,
    onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.resetWizard())),
    onPrevious: _cache[10] || (_cache[10] = ($event: any) => (_ctx.resetWizard())),
    onUpdateProfile: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateProfile())),
    dense: _ctx.dense,
    displayDeleteBtn: true,
    onDelete: _ctx.onDeleteClicked,
    onOnActive: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onActiveChange()))
  }), {
    "sub-text": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.lastImportDateFormated)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" Dernier import : " + _toDisplayString(_ctx.lastImportDateFormated), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.openDeleteDialog,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.openDeleteDialog) = $event)),
        title: "Supprimer un connecteur",
        onValid: _ctx.handleDeletion,
        error: true,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openDeleteDialog = false)),
        width: "600px"
      }, {
        default: _withCtx(() => [
          (!_ctx.name || _ctx.name.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Êtes-vous sûr de vouloir supprimer ce connecteur ? "))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, " Êtes-vous sûr de vouloir supprimer le connecteur \"" + _toDisplayString(_ctx.name) + "\" ? ", 1))
        ]),
        _: 1
      }, 8, ["modelValue", "onValid"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        style: {"min-width":"650px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_window, {
                modelValue: _ctx.wizardStep,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.wizardStep) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window_item, { value: 'authentication' }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "d-flex justify-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { class: "pa-2 border-right flex-grow-1 flex-shrink-0" }, {
                            default: _withCtx(() => [
                              _cache[14] || (_cache[14] = _createElementVNode("h3", null, "Authentification", -1)),
                              (_ctx.inputs && _ctx.inputs.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputs, (input, key) => {
                                      return (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                        key: key,
                                        modelValue: _ctx.authValues[input.key],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.authValues[input.key]) = $event),
                                        "hide-details": "",
                                        outlined: "",
                                        autocomplete: "off",
                                        class: "pa-2",
                                        label: input.label,
                                        density: "compact"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createVNode(_component_v_btn, {
                                      class: "pa-2 mt-2",
                                      rounded: "",
                                      elevation: "0",
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getConsumerConnectionUrl())),
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                                        _createTextVNode(" Se connecter ")
                                      ])),
                                      _: 1
                                    })
                                  ]))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { class: "flex-grow-0 flex-shrink-1 px-2" }, {
                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                              _createElementVNode("div", { style: {"height":"100px","width":"1px","background-color":"lightgrey","margin":"0 10px"} }, null, -1)
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { class: "pa-2 flex-grow-1 flex-shrink-0" }, {
                            default: _withCtx(() => [
                              _cache[16] || (_cache[16] = _createElementVNode("h3", null, "Options", -1)),
                              _createVNode(_component_ossDatePicker_filled, {
                                modelValue: _ctx.datePickerFormat,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.datePickerFormat) = $event)),
                                readonly: _ctx.datePickerReadOnly,
                                class: "pa-2",
                                "persistent-hint": true,
                                label: "Date de reprise",
                                textFieldReadOnly: _ctx.datePickerReadOnly,
                                hint: _ctx.datePickerHint
                              }, null, 8, ["modelValue", "readonly", "textFieldReadOnly", "hint"]),
                              (_ctx.allOptions && _ctx.allOptions.length)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.allOptions, (option) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: option.key
                                    }, [
                                      (option.type === 'boolean')
                                        ? (_openBlock(), _createBlock(_component_v_switch, {
                                            key: 0,
                                            modelValue: _ctx.optionsValues[option.key],
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.optionsValues[option.key]) = $event),
                                            label: option.label,
                                            "hide-details": ""
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                                        : _createCommentVNode("", true),
                                      (option.type === 'select')
                                        ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                            key: 1,
                                            modelValue: _ctx.optionsValues[option.key],
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.optionsValues[option.key]) = $event),
                                            label: option.label,
                                            items: option.items,
                                            "hide-details": "",
                                            class: "mt-2",
                                            density: "compact"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "items"]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, {
                        no: "",
                        gutters: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_actions, { class: "pa-2" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.lastImportDateFormated
                                                ? "Dernier import : " + _ctx.lastImportDateFormated
                                                : ""), 1),
                                  _createVNode(_component_v_spacer),
                                  (_ctx.displayImportMapping)
                                    ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                        key: 0,
                                        icon: "$fa-gear",
                                        id: "config",
                                        size: "small",
                                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.wizardStep = 'importMapping'))
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.enableSync)
                                    ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                        key: 1,
                                        icon: "$oss-sync",
                                        class: "mr-2",
                                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.wizardStep = 'refetch-connector')),
                                        size: "small"
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.accountableAccountMapping)
                    ? (_openBlock(), _createBlock(_component_v_window_item, {
                        key: 0,
                        value: 'importMapping'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SettingConnectorImportMapping, {
                            "import-mapping": _ctx.data.accountingMapping,
                            "onUpdate:importMapping": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.data.accountingMapping) = $event)),
                            companyId: _ctx.companyId,
                            onAccountChange: _ctx.updateProfile
                          }, null, 8, ["import-mapping", "companyId", "onAccountChange"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_window_item, { value: 'refetch-connector' }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SettingConnectorRefetchData, {
                        connectorId: _ctx.id,
                        companyId: _ctx.companyId,
                        origin: _ctx.origin,
                        application: _ctx.application,
                        externalId: _ctx.externalId
                      }, null, 8, ["connectorId", "companyId", "origin", "application", "externalId"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16, ["dialogBind", "width", "active", "comingSoon", "disableConfiguration", "dense", "onDelete"]))
}